import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ApimHandler } from '@api/apim-handler';
import { ApiEndpoint } from '@pages/api-portal/types';

/*
 * Fetches the catalog endpoint for the current /api-portal/catalog/:apiId route param.
 */
export function useCatalogDetail() {
    const { apiId } = useParams<{ apiId: string }>();

    const [endpoint, setEndpoint] = useState<ApiEndpoint | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);

    const fetchEndpoint = useCallback(async () => {
        setIsLoading(true);
        setNotFound(false);
        try {
            const res = await ApimHandler.fetchEndpointById(apiId);
            if (!res.data) {
                setNotFound(true);
            } else {
                setEndpoint(res.data);
            }
        } finally {
            setIsLoading(false);
        }
    }, [apiId]);

    useEffect(() => {
        fetchEndpoint();
    }, [fetchEndpoint]);

    return { endpoint, isLoading, notFound };
}
